import { IFavoriteRegionFilter, initialFavoriteRegionFilter } from "../service/api";
import create from "zustand";

export type FavoriteRegionSlot = IFavoriteRegionFilter & { isFinish?: boolean };

const initialSlot = (): FavoriteRegionSlot => ({
    ...initialFavoriteRegionFilter,
    isFinish: false,
});

interface IFavoriteRegionStore {
    filters: [FavoriteRegionSlot, FavoriteRegionSlot, FavoriteRegionSlot];
    checkedFilter: 1 | 2 | 3;
    sortType: number;
    setFilters: (state: [FavoriteRegionSlot, FavoriteRegionSlot, FavoriteRegionSlot] | ((prev: [FavoriteRegionSlot, FavoriteRegionSlot, FavoriteRegionSlot]) => [FavoriteRegionSlot, FavoriteRegionSlot, FavoriteRegionSlot])) => void;
    setCheckedFilter: (n: 1 | 2 | 3) => void;
    setSortType: (n: number) => void;
    setFilterForSlot: (slotIndex: 0 | 1 | 2, partial: Partial<IFavoriteRegionFilter> | ((prev: FavoriteRegionSlot) => FavoriteRegionSlot)) => void;
    setSlotFinish: (slotIndex: 0 | 1 | 2, isFinish: boolean) => void;
    resetFilter: () => void;
}

export const useFavoriteRegionStore = create<IFavoriteRegionStore>((set) => ({
    filters: [initialSlot(), initialSlot(), initialSlot()],
    checkedFilter: 1,
    sortType: 5,
    setFilters: (state) =>
        set((prev) => ({
            filters: typeof state === "function" ? state(prev.filters) : state,
        })),
    setCheckedFilter: (n) => set({ checkedFilter: n }),
    setSortType: (n) => set({ sortType: n }),
    setFilterForSlot: (slotIndex, partial) =>
        set((prev) => {
            const next = [...prev.filters] as [FavoriteRegionSlot, FavoriteRegionSlot, FavoriteRegionSlot];
            const slot = next[slotIndex];
            next[slotIndex] =
                typeof partial === "function"
                    ? { ...slot, ...partial(slot) }
                    : { ...slot, ...partial };
            return { filters: next };
        }),
    setSlotFinish: (slotIndex, isFinish) =>
        set((prev) => {
            const next = [...prev.filters] as [FavoriteRegionSlot, FavoriteRegionSlot, FavoriteRegionSlot];
            next[slotIndex] = { ...next[slotIndex], isFinish };
            return { filters: next };
        }),
    resetFilter: () =>
        set({
            filters: [initialSlot(), initialSlot(), initialSlot()],
            checkedFilter: 1,
        }),
}));
